import { SignalRService } from "./../../services/signalr.service";
import { Subscription } from "rxjs";
import { ForgetPassObj } from "./../../models/login";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { TwfaComponent } from "src/app/components/twfa/twfa.component";
import { AccountService } from "src/app/services/account.service";
import { AlertService } from "src/app/services/alert.service";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment.prod";
import {
  BroadcastEventListener,
  ISignalRConnection,
  SignalR,
  SignalRConfiguration,
} from "ng2-signalr";
import { UrlConstants } from "src/app/models/urlConstants";
import { GridsterService } from "src/app/services/gridster.service";
import { CompanySettings } from "src/app/models/company-settings";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-new-login",
  templateUrl: "./new-login.component.html",
  styleUrls: ["./new-login.component.scss"],
})
export class NewLoginComponent implements OnInit, OnDestroy {
  [x: string]: any;
  tfa: any;

  private _appliedBodyStyles = false;
  private _prevBodyStyles: { margin: string; height: string; overflow: string } = {
    margin: '',
    height: '',
    overflow: ''
  };

  forgetPassObj: ForgetPassObj = {} as ForgetPassObj;
  form: FormGroup;
  formForget: FormGroup;
  loading = false;
  submitted = false;
  forgetPass: boolean = false;
  resetEmail: "";
  correctEmail = false;
  remeberMe = false;
  private _subscription: Subscription;
  currentVersion = environment.version;
  private dsConnection: ISignalRConnection;
  companySettings: CompanySettings;
  isEGID = UrlConstants.isEGID;
  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private signalR: SignalR,
    private dialog: MatDialog,
    public translate: TranslateService,
    private accService: AccountService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private gridService: GridsterService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });
    this.isEGID ? null : this.GetCompanySettings();

    // If we are in the NewLoginComponent and the app is not EGID disable scrolling as per Mostafa Abdel Hamid's Request
    if (this.isEGID === false) {
      try {
        const body = document && document.body;
        if (body) {
          this._prevBodyStyles.margin = body.style.margin || '';
          this._prevBodyStyles.height = body.style.height || '';
          this._prevBodyStyles.overflow = body.style.overflow || '';

          body.style.margin = '0';
          body.style.height = '100%';
          body.style.overflow = 'hidden';
          this._appliedBodyStyles = true;
        }
      } catch (e) {
      }
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }
  get ff() {
    return this.formForget.controls;
  }

  switchLang() {
    if (this.translate.currentLang == "ar") {
      this.translate.use("en");
      this.translate.setDefaultLang("en");
      this.gridService.saveLang("en");
    } else {
      this.translate.use("ar");
      this.translate.setDefaultLang("ar");
      this.gridService.saveLang("ar");
    }
    window.location.reload();
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    if (this.form.valid) {
      this.recaptchaV3Service
        .execute("importantAction")
        .subscribe((token: string) => {
          this.accService
            .checkAuth(this.f.username.value, this.f.password.value)
            .subscribe(
              (res) => {
                this.loading = false;

                this.tfa = res;
                this.tfa.Username = this.f.username.value;

                sessionStorage.setItem("userName", this.f.username.value);
                this.twfa(this.tfa);
              },
              (err) => {
                this.loading = false;
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("login-failed-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        });
    }
  }

  connectOrdersSignalr() {
    let config: SignalRConfiguration = new SignalRConfiguration();
    config.url = UrlConstants.backofficeUrl;
    config.hubName = "dSHub";
    config.logging = false;

    this.signalR.connect(config).then((res) => {
      this.dsConnection = res;
      //open new tab with url
      var newTab = window.open(
        "truckscale:\\\\" + this.dsConnection.id,
        "_blank"
      );

      let method = new BroadcastEventListener<any>("dsNotify");

      this.dsConnection.listen(method);
      method.subscribe((update) => {
        if (newTab != null || newTab != undefined) {
          newTab.close();
          this.twfa(update);
        }
      });
    });
  }

  loginWithToken() {
    this.connectOrdersSignalr();
  }
  onForget() {
    this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        this.forgetPassObj.Email = this.formForget.value.email;
        this.accService.forgetPassword(this.forgetPassObj).subscribe((arg) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: this.translate.instant("forget-msg"),
            showConfirmButton: false,
            timer: 4500,
          });
        });
      });
  }
  forgetPassword() {
    this.forgetPass = !this.forgetPass;
    if (this.forgetPass == true) {
      this.formForget = this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]],
      });
    }
  }

  twfa(data) {
    const dialogRef = this.dialog.open(TwfaComponent, {
      // disableClose: true,
      panelClass: 'custom-dialog-style',
      width: "350px",
      data: { data: data, remeberMe: this.remeberMe },
    });
  }
  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    const element = document.getElementsByClassName(
      "grecaptcha-badge"
    )[0] as HTMLElement;
    if (element) {
      element.style.visibility = "hidden";
    }

    // restore body styles if we changed them
    if (this._appliedBodyStyles) {
      try {
        const body = document && document.body;
        if (body) {
          body.style.margin = this._prevBodyStyles.margin || '';
          body.style.height = this._prevBodyStyles.height || '';
          body.style.overflow = this._prevBodyStyles.overflow || '';
        }
      } catch (e) {}
      this._appliedBodyStyles = false;
    }
  }

  GetCompanySettings() {
    this.apiService.GetCompanySettings()
      .subscribe(
        (data: CompanySettings) => {
          this.companySettings = data;
        }
      )
  }

  get supportNumber() {
    return UrlConstants.supportNumber;
  }
}
